import { Button } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import './card-help-link.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  text: string
  link?: string
}

export default ({ text, link }: Props) => {
  const [t] = useTranslation('paymentsData')

  return (
    <div className="card-help-link">
      <span className="text">{text}</span>
      {link ? (
        <a href={link} target="_blank">
          <Button id="button-help-link" color="transparent" textColor="var(--primary_color)" size="sm" inverted>
            <span>
              <i className="fa-regular fa-arrow-up-right-from-square mr-2"></i>
              {t('knowMore')}
            </span>
          </Button>
        </a>
      ) : null}
    </div>
  )
}
